<template>
  <div>
    <div class="r-text-intro">שמחים שחזרת!</div>
    <div class="r-text-headline-paragraph">כדי להמשיך, צריך קוד אימות</div>
    <div class="r-form">
      <div class="r-form-row">
        <default-text-input
          :value="phoneNumber"
          type="tel"
          label="מספר טלפון נייד"
          autofocus
          validations="required|digits:10"
          @input="setPhoneNumber"
          @observe="observe" />
      </div>
    </div>

    <default-button label='שלחו לי קוד אימות' @click="generateCodeAndProceed" :loading="loading"/>
  </div>
</template>

<script>
import TrackedPage from '@/mixins/TrackedPage';
import ValidationObserver from '@/mixins/ValidationObserver';
import DefaultButton from '@/components/styled/DefaultButton';
import DefaultTextInput from '@/components/styled/DefaultTextInput';
import ScrollToTop from '@/mixins/ScrollToTop';
import * as LoginApi from '@/api/LoginApi';
import { mapMutations, mapState } from 'vuex';

export default {
  name: 'LoginPhone',
  data() {
    return {
      loading: false,
    };
  },
  mixins: [TrackedPage, ValidationObserver, ScrollToTop],
  components: { DefaultTextInput, DefaultButton },
  computed: {
    ...mapState('authentication', ['phoneNumber']),
  },
  methods: {
    ...mapMutations('authentication', ['setPhoneNumber']),
    async generateCodeAndProceed() {
      this.loading = true;
      try {
        const { valid } = await this.validate();
        if (valid) {
          await LoginApi.generateCode({ phoneNumber: this.phoneNumber, force: false });
          await this.$router.push({ path: 'enter-otp' });
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
